/* Par From Home · Yardage Book
   Add-to-cart upsell popup (replaces Candy Rack). Offers come from the "YB upsell popup"
   section (sections/yb-upsell.liquid). The popup opens instead of adding straight away;
   when the shopper continues or closes it, everything goes into the cart in one request. */
(function () {
  'use strict';

  // The theme editor can load this file again when the section reloads.
  if (window.YBUpsell) return;

  var CHECK =
    '<svg class="yb-pop__check" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M2.5 8.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square"/></svg>';

  var state = null;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function readConfig() {
    var dialog = qs('[data-yb-upsell]');
    var node = qs('[data-yb-upsell-config]');
    if (!dialog || !node || typeof dialog.showModal !== 'function') return null;
    var config;
    try {
      config = JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
    if (!config || !config.enabled) return null;
    config.dialog = dialog;
    config.offers = config.offers || [];
    return config;
  }

  function money(cents) {
    var value = (cents || 0) / 100;
    var currency = (state && state.cfg.currency) || 'USD';
    var whole = Math.round(value * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return '$' + (whole ? value.toFixed(0) : value.toFixed(2));
    }
  }

  function firstAvailable(product) {
    return (
      product.variants.filter(function (variant) {
        return variant.available;
      })[0] || null
    );
  }

  /* ---------- Opening ---------- */

  // request: { main: {id, productId, title, variantTitle, image, price, quantity, properties?, sellingPlan?},
  //            extras: [{id, productId, title, variantTitle, image, price, quantity}], preview: bool }
  // Returns true when the popup took over the add to cart.
  function open(request) {
    if (state) return true;
    var cfg = readConfig();
    if (!cfg || !request || !request.main || !request.main.id) return false;

    var main = request.main;
    var extras = request.extras || [];
    var taken = [main.productId].concat(
      extras.map(function (item) {
        return item.productId;
      })
    );

    // Free gifts already go into the cart with the main item (assets/yb.js), so never offer them here.
    var gifts = window.YB && typeof window.YB.giftsFor === 'function' ? window.YB.giftsFor(main.id) : [];

    var offers = cfg.offers
      .filter(function (offer) {
        var product = offer.product;
        if (!product || taken.indexOf(product.id) !== -1) return false;
        var isGift = (product.variants || []).some(function (variant) {
          return gifts.indexOf(variant.id) !== -1;
        });
        if (isGift) return false;
        if (offer.showOn && offer.showOn.length && offer.showOn.indexOf(main.productId) === -1) return false;
        return !!firstAvailable(product);
      })
      .map(function (offer) {
        return { offer: offer, variant: firstAvailable(offer.product), picked: false };
      });
    if (!offers.length) return false;

    state = {
      cfg: cfg,
      dialog: cfg.dialog,
      main: main,
      extras: extras,
      offers: offers,
      upgrade: null,
      busy: false,
      preview: !!request.preview,
      cartTotal: null,
    };

    wire(cfg.dialog);
    hideError();
    setBusy(false);
    render();
    document.documentElement.classList.add('yb-pop-lock');
    cfg.dialog.showModal();
    var body = qs('[data-yb-pop-body]', cfg.dialog);
    if (body) body.scrollTop = 0;

    // Free-shipping line counts what's already in the cart.
    if (cfg.freeShipping > 0 && !state.preview) {
      var current = state;
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (state !== current) return;
          state.cartTotal = cart.total_price || 0;
          renderShipping();
        })
        .catch(function () {});
    }
    return true;
  }

  function close() {
    if (!state) return;
    var dialog = state.dialog;
    state = null;
    document.documentElement.classList.remove('yb-pop-lock');
    if (dialog.open) dialog.close();
  }

  /* ---------- Totals and items ---------- */

  function mainPrice() {
    var unit = state.upgrade ? state.upgrade.variant.price : state.main.price || 0;
    return unit * (state.main.quantity || 1);
  }

  function totalCents() {
    var total = mainPrice();
    state.extras.forEach(function (item) {
      total += (item.price || 0) * (item.quantity || 1);
    });
    state.offers.forEach(function (entry) {
      if (entry.picked && entry.offer.kind !== 'upgrade') total += entry.variant.price;
    });
    return total;
  }

  function cartItems() {
    var list = [];
    if (state.upgrade) {
      list.push({ id: state.upgrade.variant.id, quantity: state.main.quantity || 1 });
    } else {
      var main = { id: state.main.id, quantity: state.main.quantity || 1 };
      if (state.main.properties && Object.keys(state.main.properties).length) main.properties = state.main.properties;
      if (state.main.sellingPlan) main.selling_plan = state.main.sellingPlan;
      list.push(main);
    }
    state.extras.forEach(function (item) {
      list.push({ id: item.id, quantity: item.quantity || 1 });
    });
    state.offers.forEach(function (entry) {
      if (entry.picked && entry.offer.kind !== 'upgrade') list.push({ id: entry.variant.id, quantity: 1 });
    });
    return list;
  }

  /* ---------- Rendering ---------- */

  function thumb(src) {
    var wrap = el('span', 'yb-pop__thumb');
    if (src) {
      var img = el('img');
      img.src = src;
      img.alt = '';
      img.width = 80;
      img.height = 80;
      img.loading = 'lazy';
      wrap.appendChild(img);
    }
    return wrap;
  }

  function line(title, meta, image, side) {
    var li = el('li', 'yb-pop__line');
    li.appendChild(thumb(image));
    var info = el('span', 'yb-pop__info');
    info.appendChild(el('span', 'yb-pop__name', title));
    if (meta) info.appendChild(el('span', 'yb-pop__meta', meta));
    li.appendChild(info);
    if (side) li.appendChild(side);
    return li;
  }

  function tick(text) {
    var span = el('span', 'yb-pop__tick');
    span.innerHTML = CHECK;
    span.appendChild(document.createTextNode(text));
    return span;
  }

  function metaText(variantTitle, cents, quantity) {
    var parts = [];
    if (variantTitle) parts.push(variantTitle);
    parts.push(money(cents));
    if (quantity > 1) parts.push(state.cfg.labels.qty + ' ' + quantity);
    return parts.join(' · ');
  }

  function render(focusKey) {
    var cfg = state.cfg;
    var labels = cfg.labels;
    var body = qs('[data-yb-pop-body]', state.dialog);
    if (!body) return;
    body.textContent = '';

    body.appendChild(el('p', 'yb-pop__label', labels.included));
    var mine = el('ul', 'yb-pop__lines');
    var qty = state.main.quantity || 1;
    if (state.upgrade) {
      var side = el('span', 'yb-pop__side');
      side.appendChild(tick(labels.upgraded));
      var undo = el('button', 'yb-pop__undo', labels.undo);
      undo.type = 'button';
      undo.setAttribute('data-yb-pop-action', 'undo');
      undo.setAttribute('data-focus-key', 'undo');
      side.appendChild(undo);
      var product = state.upgrade.offer.product;
      var variant = state.upgrade.variant;
      mine.appendChild(
        line(product.title, metaText(variant.title, variant.price * qty, qty), variant.image || product.image, side)
      );
    } else {
      mine.appendChild(
        line(
          state.main.title,
          metaText(state.main.variantTitle, (state.main.price || 0) * qty, qty),
          state.main.image,
          tick('')
        )
      );
    }
    state.extras.forEach(function (item) {
      var q = item.quantity || 1;
      mine.appendChild(line(item.title, metaText(item.variantTitle, (item.price || 0) * q, q), item.image, tick('')));
    });
    body.appendChild(mine);

    body.appendChild(el('p', 'yb-pop__label', labels.offers));
    var list = el('ul', 'yb-pop__lines');
    state.offers.forEach(function (entry, index) {
      list.appendChild(offerRow(entry, index));
    });
    body.appendChild(list);

    var total = qs('[data-yb-pop-total]', state.dialog);
    if (total) total.textContent = money(totalCents());
    renderShipping();

    if (focusKey) {
      var target = qs('[data-focus-key="' + focusKey + '"]', state.dialog);
      if (target) target.focus();
    }
  }

  function offerRow(entry, index) {
    var labels = state.cfg.labels;
    var offer = entry.offer;
    var product = offer.product;
    var variant = entry.variant;
    var isUpgrade = offer.kind === 'upgrade';

    var li = el('li', 'yb-pop__offer' + (entry.picked ? ' is-picked' : ''));
    li.appendChild(thumb(variant.image || product.image));

    var info = el('span', 'yb-pop__info');
    info.appendChild(el('span', 'yb-pop__name', product.title));
    var price = el('span', 'yb-pop__price');
    price.appendChild(el('b', '', money(variant.price)));
    if (variant.compare > variant.price) price.appendChild(el('s', '', money(variant.compare)));
    info.appendChild(price);
    if (offer.text) info.appendChild(el('span', 'yb-pop__text', offer.text));

    var choices = product.variants.filter(function (v) {
      return v.available;
    });
    if (choices.length > 1) {
      var select = el('select', 'yb-pop__select');
      select.setAttribute('data-yb-pop-variant', '');
      select.setAttribute('data-index', String(index));
      select.setAttribute('data-focus-key', 'variant-' + index);
      select.setAttribute('aria-label', product.title);
      choices.forEach(function (choice) {
        var option = el('option', '', choice.title);
        option.value = String(choice.id);
        if (choice.id === variant.id) option.selected = true;
        select.appendChild(option);
      });
      info.appendChild(select);
    }
    li.appendChild(info);

    var button = el('button', 'yb-btn yb-pop__btn' + (entry.picked ? ' is-on' : ' yb-btn--accent'));
    button.type = 'button';
    button.setAttribute('data-yb-pop-action', 'toggle');
    button.setAttribute('data-index', String(index));
    button.setAttribute('data-focus-key', 'offer-' + index);
    button.setAttribute('aria-pressed', entry.picked ? 'true' : 'false');
    var text;
    if (isUpgrade) {
      var delta = (variant.price - (state.main.price || 0)) * (state.main.quantity || 1);
      text = entry.picked ? labels.upgraded : labels.upgrade + (delta > 0 ? ' · +' + money(delta) : '');
    } else {
      text = entry.picked ? labels.added : labels.add + ' · ' + money(variant.price);
    }
    if (entry.picked) button.innerHTML = CHECK;
    button.appendChild(document.createTextNode(text));
    button.setAttribute('aria-label', text + ': ' + product.title);
    li.appendChild(button);
    return li;
  }

  function renderShipping() {
    if (!state) return;
    var node = qs('[data-yb-pop-ship]', state.dialog);
    if (!node) return;
    var threshold = state.cfg.freeShipping || 0;
    if (!threshold || state.cartTotal === null) {
      node.hidden = true;
      return;
    }
    var total = state.cartTotal + totalCents();
    node.hidden = false;
    if (total >= threshold) {
      node.textContent = state.cfg.labels.shipFree;
      node.classList.add('is-free');
    } else {
      node.textContent = state.cfg.labels.shipAway.replace('[amount]', money(threshold - total));
      node.classList.remove('is-free');
    }
  }

  function hideError() {
    var node = state && qs('[data-yb-pop-error]', state.dialog);
    if (node) {
      node.hidden = true;
      node.textContent = '';
    }
  }

  function showError(message) {
    var node = state && qs('[data-yb-pop-error]', state.dialog);
    if (node) {
      node.textContent = message;
      node.hidden = false;
    }
  }

  function setBusy(on, action) {
    if (!state) return;
    state.busy = on;
    var cont = qs('[data-yb-pop-continue]', state.dialog);
    qsa('button, select', state.dialog).forEach(function (control) {
      control.disabled = on;
    });
    if (cont) {
      cont.setAttribute('aria-busy', on ? 'true' : 'false');
      cont.textContent = on && action === 'continue' ? state.cfg.labels.busy : state.cfg.labels.continue;
    }
  }

  /* ---------- Actions ---------- */

  function toggle(index) {
    var entry = state.offers[index];
    if (!entry) return;
    if (entry.offer.kind === 'upgrade') {
      var on = !entry.picked;
      state.offers.forEach(function (other) {
        if (other.offer.kind === 'upgrade') other.picked = false;
      });
      entry.picked = on;
      state.upgrade = on ? { offer: entry.offer, variant: entry.variant } : null;
    } else {
      entry.picked = !entry.picked;
    }
    render('offer-' + index);
  }

  function undoUpgrade() {
    var index = -1;
    state.offers.forEach(function (entry, i) {
      if (entry.offer.kind === 'upgrade' && entry.picked) index = i;
      if (entry.offer.kind === 'upgrade') entry.picked = false;
    });
    state.upgrade = null;
    render(index > -1 ? 'offer-' + index : null);
  }

  function chooseVariant(select) {
    var entry = state.offers[parseInt(select.getAttribute('data-index'), 10)];
    if (!entry) return;
    var chosen = entry.offer.product.variants.filter(function (v) {
      return String(v.id) === select.value;
    })[0];
    if (!chosen) return;
    entry.variant = chosen;
    if (entry.picked && entry.offer.kind === 'upgrade') state.upgrade = { offer: entry.offer, variant: chosen };
    render(select.getAttribute('data-focus-key'));
  }

  // action: 'continue' (main button) or 'close' (X, Escape, backdrop).
  function finish(action) {
    if (!state || state.busy) return;
    if (state.preview) {
      close();
      return;
    }
    var api = window.YB;
    if (!api || typeof api.addItems !== 'function') {
      close();
      return;
    }
    var toCheckout = action === 'continue' && state.cfg.after !== 'drawer';
    var items = cartItems();
    var current = state;
    hideError();
    setBusy(true, action);
    api
      .addItems(items, { drawer: !toCheckout, beforeRender: close })
      .then(function () {
        if (state !== current) return;
        if (toCheckout) {
          window.location.href = '/checkout';
          return;
        }
        close();
      })
      .catch(function (error) {
        if (state !== current) return;
        setBusy(false);
        showError((error && error.isCartError && error.message) || state.cfg.labels.error);
      });
  }

  function outside(dialog, event) {
    if (event.target !== dialog) return false;
    var rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom
    );
  }

  function wire(dialog) {
    if (dialog.__ybWired) return;
    dialog.__ybWired = true;

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      finish('close');
    });

    // Some browsers close a modal on a second Escape press anyway: treat it like the X.
    dialog.addEventListener('close', function () {
      if (state && state.dialog === dialog && !state.busy) finish('close');
    });

    // The backdrop closes it only when the press starts and ends outside the panel
    // (not a text selection dragged out of it, not a click on its border).
    var pressedOutside = false;
    dialog.addEventListener('pointerdown', function (event) {
      pressedOutside = outside(dialog, event);
    });
    dialog.addEventListener('click', function (event) {
      if (!state) return;
      if (event.target === dialog) {
        if (pressedOutside && outside(dialog, event)) finish('close');
        pressedOutside = false;
        return;
      }
      var button = event.target.closest('[data-yb-pop-action]');
      if (!button || state.busy) return;
      var action = button.getAttribute('data-yb-pop-action');
      if (action === 'close') finish('close');
      else if (action === 'continue') finish('continue');
      else if (action === 'toggle') toggle(parseInt(button.getAttribute('data-index'), 10));
      else if (action === 'undo') undoUpgrade();
    });

    dialog.addEventListener('change', function (event) {
      var select = event.target.closest('[data-yb-pop-variant]');
      if (select && state && !state.busy) chooseVariant(select);
    });
  }

  /* ---------- Dawn product forms (balls, mat, band and other default product pages) ---------- */

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !form.closest('product-form') || form.closest('[data-yb-buy]')) return;
      var cfg = readConfig();
      if (!cfg || !cfg.current) return;
      var data = new FormData(form);
      var hasFile = false;
      data.forEach(function (value) {
        if (typeof value !== 'string' && value && value.size) hasFile = true;
      });
      if (hasFile) return;
      var id = parseInt(data.get('id'), 10);
      var variant = cfg.current.variants.filter(function (v) {
        return v.id === id;
      })[0];
      if (!variant) return;
      var properties = {};
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
      });
      var opened = open({
        main: {
          id: id,
          productId: cfg.current.id,
          title: cfg.current.title,
          variantTitle: variant.title,
          image: variant.image || cfg.current.image,
          price: variant.price,
          quantity: Math.max(1, parseInt(data.get('quantity'), 10) || 1),
          properties: properties,
          sellingPlan: data.get('selling_plan') || null,
        },
      });
      if (opened) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  // Back from checkout: the browser can restore this page exactly as it was left
  // (popup open and busy), so start over.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && state) close();
  });

  /* ---------- Theme editor preview ---------- */

  function preview() {
    var cfg = readConfig();
    if (!cfg || !cfg.current || !cfg.current.variants.length) return;
    if (state) close();
    var variant = cfg.current.variants[0];
    open({
      preview: true,
      main: {
        id: variant.id,
        productId: cfg.current.id,
        title: cfg.current.title,
        variantTitle: variant.title,
        image: variant.image || cfg.current.image,
        price: variant.price,
        quantity: 1,
      },
    });
  }

  function isUpsellSection(event) {
    return !!(event.target && event.target.querySelector && event.target.querySelector('[data-yb-upsell]'));
  }

  document.addEventListener('shopify:section:select', function (event) {
    if (isUpsellSection(event)) preview();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (isUpsellSection(event) && state && !state.dialog.isConnected) state = null;
    if (isUpsellSection(event)) {
      document.documentElement.classList.remove('yb-pop-lock');
      preview();
    }
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (isUpsellSection(event) && state && state.preview) close();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (state && event.target && event.target.contains && event.target.contains(state.dialog)) close();
  });

  window.YBUpsell = { open: open };
})();
